import script from "./UploadFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFilter.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/addUpload.css?vue&type=style&index=0&id=37271e92&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37271e92"]])

export default __exports__